import { BaseContainerModel } from "../../base-container.model";
import { bl_fi_pd_cheque_processing_queue_history_RowClass,  } from "../../../dbschema";

export class PostDatedChequeProcessingQueueHistoryContainerModel extends BaseContainerModel {
    bl_fi_pd_cheque_processing_queue_history: bl_fi_pd_cheque_processing_queue_history_RowClass = new bl_fi_pd_cheque_processing_queue_history_RowClass();
}
